export default "__VITE_ASSET__DktmfRYA__"